export const snackbarDelay = 5000;

export const contactDetails = {
  company: 'nChain',
  name: 'Mihael Medved',
  email: 'm.medved@nchain.com',
};
